import questionSets from './questions';

export const aeciISMaturityModel = {
  name: 'AECI IS Maturity Model',
  key: 'aeci-is-maturity-model',
  question_sets: questionSets,
};

export default aeciISMaturityModel;
